import { render, staticRenderFns } from "./SimpleRepairPlanCommentsRegisterPage.vue?vue&type=template&id=67ae4fe6&"
import script from "./SimpleRepairPlanCommentsRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./SimpleRepairPlanCommentsRegisterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports